import { render, staticRenderFns } from "./PurgeWarning.vue?vue&type=template&id=1468e178&"
import script from "./PurgeWarning.vue?vue&type=script&lang=ts&"
export * from "./PurgeWarning.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports